import { NgModule } from '@angular/core';
import { MatSelectModule } from '@angular/material/select';

@NgModule({
  imports: [MatSelectModule],
  exports: [MatSelectModule]
})
export class TiimeSelectModule {}
